<!-- Here we display tde answers -->
<div class="main-container">
  <div class="container pl-md-0">
    <div class="row pt-3">
      <div class="col-md-12">
          <img src="../../assets/ipc-logo.png" class="ipc-logo" alt="ipc logo">
      </div>
    </div>
  </div>
  <div class="container mb-5 pl-md-0 mt-5 mt-md-5 pt-0 pt-md-5">
    <div class="row">
      <div class="col text-left mb-4">
        <!-- <button class="btn btn-outline-primary" [routerLink]="['/form']">Back</button> -->
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 offset-md-3">
        <div class="text-center mb-4">
          <button class="btn btn-outline-primary" (click)="generatePdf()">Download Report</button><br><br>
            <!-- A button allows us to start the quiz over, and a click event resets the user answers -->
            <button class="btn btn-outline-primary btn-restart" (click)="clear()">Restart the assessment</button>
        </div>
        <div class="text-center">
          <img src="../../assets/report-preview.jpg" width="100%" alt="report cover page">
        </div>



        <!-- <div>
          <div style='page-break-after: always'>
            <h2>Client Information:</h2>
            <p style="text-decoration: underline;"><span><strong>First Name:</strong> {{formObject.fcfName}}</span>
              <span><strong>Last Name:</strong> {{formObject.fclName}}</span></p>
            <p style="text-decoration: underline;"><span><strong>First Name:</strong> {{formObject.scfName}}</span>
              <span><strong>Last Name:</strong> {{formObject.sclName}}</span></p>



            <h2>Advisor Information:</h2>
            <p style="text-decoration: underline;"><span><strong>First Name:</strong> {{formObject.fafName}} </span>
              <span><strong>Last Name:</strong> {{formObject.falName}}</span></p>
            <p style="text-decoration: underline;"><span><strong>First Name:</strong> {{formObject.safName}} </span>
              <span><strong>Last Name:</strong> {{formObject.salName}}</span></p>
            <div>
              <p><strong>Summary:</strong> {{commentObject.comments}}</p>
            </div>

            <p><strong>Disclaimer:</strong> This report should not be construed to be financial, investment, tax, legal,
              or accounting advice.
              Rather, it provides you with general estate planning information that you may wish to consider. This
              report is not intended to be comprehensive in nature, and is not a substitution for the services of a
              legal, tax or licensed insurance specialist. You are encouraged to consult with professional specialists
              before using the information in this report.</p>
            <p>The information contained in this report is based on the provisions of the Income Tax Act (Canada) and
              the Income Tax Regulations in force at January 1, 2020 (the "Act"). The Act, its judicial interpretation,
              and the administrative policies of the Canada Revenue Agency (CRA), are subject to change. Any changes to
              these laws and regulations could impact the information represented in this report.</p>
            <p>IPC Investment Corporation, IPC Securities Corporation and its affiliates assume no liability for any
              damages that may be incurred by you as a result of relying on the report's content.</p>
          </div>
        </div>
        <div>
          <div>
            <p><strong>Estate Report</strong></p>
            <p>The following is your Personal Estate Planning Report. It provides various estate planning strategies to
              consider based on the responses you provided in the IPC Estate Planning Questionnaire and can help our
              team
              address your potential questions and concerns.</p>

            <p>Planning ahead helps to ensure your estate planning objectives are met and may help you to maximize the
              value of your estate. </p>

            <p>I look forward to discussing this report with you further.</p>

            <div *ngFor="let answer of quiz?.answers">
              <p><strong>{{answer.question}}</strong>
              <p>
              <ul class="mb-0">
                <li *ngFor="let point of answer?.points">
                  {{point}}
                </li>
              </ul>
              <div class="answerDescription" [innerHTML]="answer.description"></div>
            </div>
          </div>
        </div> -->

      </div>
    </div>
  </div>
</div>
<footer class="footer">
  <div class="container pl-md-0">
    <div class="row">
      <div class="col-md-12 top-footer-text mt-4 text-center">
        <!-- <h3 class="font-weight-bold">HEAD OFFICE</h3>
        <p>5015 Spectrum Way. Mississauga, ON. Canada</p>
        <p>Phone: <a class="top-footer-text" href="tel:905-212-9799">905-212-9799</a></p>
        <hr class="footer-hr"> -->
        <p class="bottom-footer-text">© 2020 <a class="bottom-footer-text" href="https://www.ipcc.ca"
            target="_blank">Investment Planning
            Counsel</a></p>
      </div>
    </div>
  </div>
</footer>